export default __webpack_public_path__ + "static/media/money-sign.fff67da8.svg";